// Cat's Atelier PDP behaviour. Loaded only on CA product pages. Spec §9.
(function () {
  if (!document.querySelector('.ca-pdp')) return;

  // In-memory selection state. Prestige's Section Rendering API swaps the whole
  // main-product section HTML on every variant change (~280ms), which wipes:
  //   • hidden properties[...] inputs written by injectProperty()
  //   • .ca-swatch--active classes on swatches
  //   • select element values
  //   • the <dialog> drawer element (fresh node with no listeners)
  // We keep the canonical truth here and restore the DOM after each rerender.
  const caSelectedState = Object.create(null);
  // T-754 (2026-08-05): the follow-default tracking that used to live here is GONE.
  // Martin's ruling: "We should default upon landing, after that we should never auto change."
  // Base Fabric still MATCHES the landed cushion colour (rendered by Liquid via
  // ca_base_follows, so the gallery photo is right on arrival), but nothing moves it
  // afterwards — every later change is the customer's. caUserTouched went with it: it only
  // existed to decide when to STOP following, and there is no following left to stop.
  // T-650: the curated favourite combo, emitted by Liquid as data — the initial DOM state
  // now varies with the landed variant, so "popular" must be compared against data.
  var caPopular = (function () {
    try {
      var el = document.querySelector('.ca-combo-trigger-wrap[data-ca-popular]');
      return el ? JSON.parse(el.dataset.caPopular) : null;
    } catch (e) { return null; }
  })();

  // ---- T-539 finish-aware preview ------------------------------------------
  // Map of "<colour-slug>|<finish-slug>" -> Shopify Files CDN url, exposed by
  // cats-atelier-pdp.liquid as a JSON <script>. On any cushion-colour OR Wood
  // Finish change we point the modal preview + main hero at the exact combo.
  // PERFORMANCE: nothing loads at page render. Natural finishes reuse the
  // already-loaded gallery image (no fetch). Only a STAINED finish triggers a
  // single image fetch, auto-served by the CDN as ~40KB WebP (Accept negotiation)
  // capped with &width. So the only network cost is one small WebP per stained
  // selection, after load — page-load CWV is unaffected.
  var caFinishMap = (function () {
    try {
      var el = document.querySelector('script.ca-finish-images-data');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) { return {}; }
  })();
  function caSlug(s){ return (s || '').toString().trim().toLowerCase().replace(/\s+/g, '-'); }
  function caFinishSlug(v){ v = (v || '').toString().trim(); return /^natural/i.test(v) ? 'natural' : caSlug(v); }
  function caCdn(url, w){
    if (!url) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 1100);
  }
  function caCushionColour(){
    var firstGroup = document.querySelector('.ca-swatches[data-ca-required="true"]');
    var prop = firstGroup && firstGroup.dataset.caProperty;
    return prop ? caSelectedState[prop] : null;
  }
  // Full "with <Colour> DOT cushion" so "Grey" does NOT match "Dark Grey DOT cushion".
  function caCushionNeedle(colour){ return 'with ' + colour + ' DOT cushion'; }
  // The already-loaded gallery image for a cushion colour.
  function caNaturalUrlFor(colour){
    if (!colour) return null;
    var needle = caCushionNeedle(colour);
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].alt && imgs[i].alt.indexOf(needle) !== -1) return imgs[i].currentSrc || imgs[i].src;
    }
    return null;
  }
  // T-539: the finish preview is MODAL-ONLY. We deliberately do NOT manipulate Prestige's main
  // gallery carousel — doing so corrupted its state (a stale "original src" capture left the main
  // image stuck on the wrong frame and not updating on modal close). The main gallery keeps its
  // native behaviour (fabric -> variant featured image, via Prestige's rerender + caCushionSwap);
  // the wood finish is shown in the modal's .ca-modal-preview__img only.
  function applyFinishPreview(){
    if (!caFinishMap || !Object.keys(caFinishMap).length) return;   // no map -> legacy behaviour
    var preview = document.querySelector('.ca-modal-preview__img');
    if (!preview) return;                                           // no modal preview -> nothing to do
    var colour = caCushionColour();
    if (!colour) return;
    var finish = caSelectedState['Wood Finish'];
    // Source the modal preview from the colour|finish map (covers every finish incl. Natural). This is
    // robust to the variant-approach alt change (the old "<Colour> DOT cushion" alt-match no longer applies);
    // fall back to the loaded gallery image for any product without a map entry.
    var u = caFinishMap[caSlug(colour) + '|' + caFinishSlug(finish || 'natural')];
    var target = u ? caCdn(u, 1100) : caNaturalUrlFor(colour);
    if (target && preview.src !== target) preview.src = target;
  }
  // T-543: mirror the PDP variant price (Prestige's <price-list>, updated on variant change) into the
  // modal footer so the price tracks Size/Colour/Finish selections (matters for 2-size cozy/sunny).
  function updateModalPrice(){
    // T-599: scope the read to THIS product's price only. The old selector's bare `price-list`
    // fallback matched by document order, so a non-empty cart's first line-item <price-list>
    // (rendered before the product body) leaked the CART product's price into the CA modal.
    // .price-list--product is unique to the main PDP price (price-list.liquid context=='product'),
    // and both branches are scoped to .product-info, which never wraps a cart line item.
    var pl = document.querySelector('.product-info price-list.price-list--product')
          || document.querySelector('.product-info price-list');
    if (!pl) return;
    var m = (pl.textContent || '').match(/[£$€][\d.,]+/);
    if (!m) return;
    document.querySelectorAll('.ca-drawer-price[data-ca-price]').forEach(function(el){
      if (el.textContent.trim() !== m[0]) el.textContent = m[0];
    });
  }
  // --------------------------------------------------------------------------

  // ============================================================
  // T-758 (2026-08-05) — WHATEVER SIZE THE DRAWER OPENS AT, IT KEEPS.
  //
  // Martin, after the modal was reported three times: "we just need to ensure that whatever the
  // size of the modal upon opening that never changes when variants are selected".
  //
  // WHY THIS IS NOT SOLVED IN CSS. The drawer is content-sized under `max-height:88vh`, so
  // whenever the content is shorter than the cap the box tracks its content: swap the preview
  // image, show an OOS tag, wrap a label, and the modal resizes — and because it is
  // bottom-anchored (`margin:auto auto 0`) it moves as well. Measured on live: the Cat Wall Step
  // drawer was 514px against an 836px cap, the C&G drawer 780.4px at EVERY viewport height.
  // A blanket `height:88vh` would fix the movement but force every modal to full height, giving
  // low-option products ~300px of empty sheet — the blunt fix Martin explicitly ruled out.
  //
  // So we freeze the height it opened at. Content may then change freely; the body already
  // scrolls (`overflow-y:auto`), so nothing is ever unreachable.
  //
  // MOBILE ONLY (<=749px): the reported defect is mobile, and on desktop the drawer is a centred
  // card where content-sizing looks correct. Re-measured on resize/orientation change so a
  // rotated phone gets a correctly-sized sheet rather than a stale one. Cleared on close so the
  // next open measures afresh (a different product/variant legitimately needs a different size).
  // Twin implementation in cg-selectors.js — keep the two in step.
  // ============================================================
  // ============================================================
  // T-760 (2026-08-05) — LOCK THE PAGE WHILE THE SHEET IS OPEN.
  //
  // Martin: "when scrolling the modal it also scrolls the background which it shouldn't", and
  // "if I scroll all the way to the bottom the header of the modal scrolls out of view and the
  // Done/Atc buttons move up". THOSE ARE ONE BUG, not two.
  //   - Measured on Test: with the sheet open the page scrolled CA 914 -> 1314, C&G 738 -> 1138.
  //     `html`/`body` overflow are both `visible` and `showModal()` does NOT lock page scroll.
  //   - The header symptom did not reproduce in Chromium because the dialog is `position:fixed`,
  //     so a page scroll cannot move it on a desktop engine. On a real phone a page scroll
  //     ANIMATES THE BROWSER TOOLBAR, the visual viewport shifts, and a bottom-anchored fixed
  //     sheet visibly slides — header off the top, footer upward.
  //   - And it is easy to hit: measured bodyScroll 0/0 at 891px, i.e. at that height the content
  //     FITS, so there is nothing to scroll inside the drawer and every swipe hits the page.
  // Stop the page moving and both symptoms go with it.
  //
  // `position:fixed` on <body> rather than `overflow:hidden` on <html>: the latter is ignored by
  // iOS Safari. Restoring the scroll position on unlock is what makes it invisible to the user.
  // MOBILE ONLY (<=749px) — on desktop, removing the page scrollbar changes layout width by
  // ~15px, which is exactly the T-756 nudge, and the bug is mobile.
  // Twin implementation in cg-selectors.js — keep the two in step.
  // ============================================================
  var caScrollLockY = 0;
  function lockBackgroundScroll(){
    if (window.innerWidth > 749) return;
    if (document.body.dataset.caScrollLocked === '1') return;
    caScrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-caScrollLockY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    b.dataset.caScrollLocked = '1';
  }
  function unlockBackgroundScroll(){
    var b = document.body;
    if (b.dataset.caScrollLocked !== '1') return;
    b.style.position = ''; b.style.top = ''; b.style.left = '';
    b.style.right = ''; b.style.width = ''; b.style.overflow = '';
    delete b.dataset.caScrollLocked;
    window.scrollTo(0, caScrollLockY);
  }
  // Bound to the dialog's own `close` event so EVERY exit is covered by one path — Done, the X,
  // the backdrop, in-drawer Add, and the ESC key (which no click handler can see).
  function bindScrollUnlock(dlg){
    if (!dlg || dlg._caScrollBound) return;
    dlg.addEventListener('close', unlockBackgroundScroll);
    dlg._caScrollBound = true;
  }

  function lockDrawerHeight(dlg){
    if (!dlg || !dlg.open) return;
    if (window.innerWidth > 749) { dlg.style.height = ''; return; }
    dlg.style.height = '';               // measure the natural size, not a stale lock
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        if (!dlg.open) return;
        var h = dlg.getBoundingClientRect().height;
        if (h > 0) dlg.style.height = Math.round(h) + 'px';
      });
    });
  }
  function unlockDrawerHeight(dlg){ if (dlg) dlg.style.height = ''; }
  window.addEventListener('resize', function(){
    var open = document.querySelector('dialog.ca-combo-drawer[open]');
    if (open) lockDrawerHeight(open);
  });

  // Drawer open/close — DELEGATED to document because the trigger element and
  // <dialog> are both replaced on variant change; direct listeners attached at
  // init time would point to orphan nodes. Fresh queries each click.
  document.addEventListener('click', function(e){
    if (e.target.closest('.ca-combo-trigger')) {
      const dlg = document.querySelector('dialog.ca-combo-drawer');
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
        // T-826 (2026-10-07): read the pill's state BEFORE opening. The pill carries
        // .ca-combo-trigger--error only after a failed Add to Basket (setTriggerError, via
        // validate()), so it tells an open the customer chose apart from one the "Please choose"
        // error pushed them into (e.g. the mobile sticky bar's ATC with nothing picked).
        var caOpenTrigger = e.target.closest('.ca-combo-trigger').classList.contains('ca-combo-trigger--error') ? 'pill_error' : 'pill';
        dlg.showModal();
        // T-826: rebuilds the option-modal-open telemetry lost when T-516 replaced Infinity
        // Options (dpc-io-validation-tracking.js, which fired these events, left the live theme
        // and nothing replaced them). CA's Add to Basket lives INSIDE this drawer
        // (.ca-drawer-add), so this event is the missing middle step of the real funnel:
        // view_item -> select_options_open -> add_to_cart. `pid` is assigned once, below
        // (var-hoisted, already set by the time a user can click), from the .ca-pdp wrapper's
        // data-product-id. 749px matches the mobile/desktop split already used elsewhere in
        // this file (see lockDrawerHeight above). Guarded exactly like the existing
        // miacara_import_info_click pattern (cart-shipping-message.liquid) to preserve consent
        // gating and the web pixel -- do not hand-roll a defer loader here.
        if (typeof gtag === 'function') {
          gtag('event', 'select_options_open', {
            item_id: pid,
            // T-826 (2026-10-07): handle from the URL (/products/<handle>, also under
            // /collections/<c>/products/<handle>) so no Liquid hook is needed; '' if absent.
            product_handle: ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || ''),
            vendor: "Cat's Atelier",
            device: window.innerWidth <= 749 ? 'mobile' : 'desktop',
            open_trigger: caOpenTrigger
          });
        }
        // T-276 Path A: refresh the in-modal preview to match the current
        // cushion-fabric selection (which may have been changed via inline
        // chips on desktop, or restored via Section Rendering API rerender)
        var firstGroup = document.querySelector('.ca-swatches[data-ca-required="true"]');
        if (firstGroup) {
          var active = firstGroup.querySelector('.ca-swatch--active');
          if (active && active.dataset.caVal) updateModalPreview(active.dataset.caVal);
        }
      }
      applyFinishPreview();   // T-539: sync preview to the current colour+finish combo on drawer open
      updateModalPrice();     // T-543
      // T-760: lock the page FIRST — <body> going position:fixed changes layout, so the T-758
      // height measurement below must happen after it, not before.
      var openDlg = document.querySelector('dialog.ca-combo-drawer[open]');
      if (openDlg) { lockBackgroundScroll(); bindScrollUnlock(openDlg); }
      // T-758: lock the height LAST — after the preview image and price are set, so we freeze the
      // size the customer actually sees rather than a pre-populate intermediate.
      lockDrawerHeight(openDlg);
      return;
    }
    if (e.target.classList && e.target.classList.contains('ca-combo-drawer')) {
      // Backdrop click (native <dialog> reports target === dialog for backdrop hits).
      if (e.target.open) { unlockDrawerHeight(e.target); e.target.close(); }
      return;
    }
    if (e.target.closest('.ca-drawer-close')) {
      const open = document.querySelector('dialog.ca-combo-drawer[open]');
      if (open) { unlockDrawerHeight(open); open.close(); }
    }
  });

  // T-486: in-modal "Add to Basket" — mirrors the feeder modal. Run CA's existing
  // required-property validation FIRST; if anything is unchosen, validate() paints the
  // per-field errors inside the open drawer and we keep it open. If valid, close the
  // drawer and click the page's real ATC (type="submit" inside <buy-buttons> — Prestige's
  // button has no name="add"); its form submit re-runs validate() via the capture handler.
  document.addEventListener('click', function(e){
    if(!e.target.closest('.ca-drawer-add')) return;
    if(!validate()) return; // errors shown in-drawer; do not close or add
    var dlg = document.querySelector('dialog.ca-combo-drawer[open]');
    if(dlg) { unlockDrawerHeight(dlg); dlg.close(); }   // T-758: clear the lock so the next open re-measures
    var atc = document.querySelector(
      'buy-buttons button[type="submit"], ' +
      'product-form button[type="submit"]:not(quick-buy button), ' +
      '.product-info__block-item[data-block-type="buy-buttons"] button[type="submit"], ' +
      'form[action*="/cart/add"] button[type="submit"]:not([form*="quick"])'
    );
    if(atc) atc.click();
  });

  // T-486 phase 2: modal Size/Curve-Shape mirror buttons proxy to the hidden native radios,
  // so all variant axes are chosen inside the modal. Mirrors the active state across the
  // dialog + inline copies and survives Prestige's section rerender.
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.ca-vmirror-btn');
    if(!btn || btn.disabled) return;
    var group = btn.closest('.ca-vmirror-group');
    if(!group) return;
    var axis = group.dataset.caVmirrorAxis || '';
    var val = btn.dataset.caVmirrorVal || '';
    document.querySelectorAll('.ca-vmirror-group[data-ca-vmirror-axis="' + CSS.escape(axis) + '"] .ca-vmirror-btn').forEach(function(b){ b.classList.remove('ca-vmirror-btn--active'); b.setAttribute('aria-pressed','false'); });
    document.querySelectorAll('.ca-vmirror-group[data-ca-vmirror-axis="' + CSS.escape(axis) + '"] .ca-vmirror-btn[data-ca-vmirror-val="' + CSS.escape(val) + '"]').forEach(function(b){ b.classList.add('ca-vmirror-btn--active'); b.setAttribute('aria-pressed','true'); });
    setVariantByOption(axis, val);
    applyScrollLock(900);
    // T-752: liftDialogToBody() FIRST — see the variant:change handler for why order matters.
    setTimeout(function(){ hideAllVariantFieldsets(); liftDialogToBody(); syncVmirrorFromNative(); restoreSelections(); }, 550);
    setTimeout(function(){ hideAllVariantFieldsets(); liftDialogToBody(); syncVmirrorFromNative(); restoreSelections(); }, 1100);
  });

  // Trigger sync — label shows EXACTLY what's selected, dots paint to match.
  // Design rule (2026-04-22 Round 4): the label must name the selected colours
  // at any time, so customers can see their current choices without opening the
  // drawer. Before anything is picked, the label falls back to the default
  // category placeholder (data-default-label).
  // ── T-759: show the chosen value next to the group heading ──────────
  // The swatches are now colour dots with no visible name (Martin: "larger circle swatches and
  // the name of the colour to show alongside the variant name"), so this is where the customer
  // reads their selection — "UPPER CUSHION FABRIC — Cream". Twin of updateSelectedNames() in
  // cg-selectors.js; keep the two in step.
  // Queries via document each time because `.ca-pdp` is replaced on every variant rerender, and
  // updates BOTH renderings (mobile dialog + desktop inline) since they share the axis name.
  function updateSelectedNames() {
    document.querySelectorAll('.ca-selector-selected[data-ca-selected-axis]').forEach(function (el) {
      var axis = el.dataset.caSelectedAxis;
      var group = document.querySelector('.ca-swatches[data-ca-property="' + CSS.escape(axis) + '"]');
      var active = group && group.querySelector('.ca-swatch--active');
      var val = active ? (active.dataset.caVal || '') : '';
      el.textContent = val ? ' — ' + val : '';
    });
  }

  function updateComboTrigger() {
    updateSelectedNames();   // T-759 — same call sites as the trigger label, so it can never drift
    // Query via document (not a captured root) — `.ca-pdp` is replaced on each variant
    // rerender, so any captured reference would be detached after the first size change.
    const trigger = document.querySelector('.ca-combo-trigger');
    if (!trigger) return;
    const labelEl = trigger.querySelector('.ca-combo-trigger-label');
    const defaultLabel = trigger.dataset.defaultLabel || '';

    // Deduplicate by data-ca-property (selectors render twice: mobile dialog + desktop inline).
    // Swatch groups populate both the label and the dots; select groups populate only the label.
    const seen = new Set();
    const allPicked = [];       // in render order — used for the label
    const swatchPicked = [];    // swatch-only — used for dot painting

    for (const g of document.querySelectorAll('.ca-swatches[data-ca-required="true"]')) {
      const prop = g.dataset.caProperty;
      if (seen.has(prop)) continue;
      seen.add(prop);
      const active = g.querySelector('.ca-swatch--active');
      const entry = {
        value: active ? (active.dataset.caVal || '') : '',
        dotBg: active ? getComputedStyle(active.querySelector('.ca-swatch__dot') || active).backgroundColor : ''
      };
      allPicked.push(entry);
      swatchPicked.push(entry);
    }
    for (const s of document.querySelectorAll('.ca-select[data-ca-required="true"]')) {
      const prop = s.dataset.caProperty;
      if (seen.has(prop)) continue;
      seen.add(prop);
      allPicked.push({ value: s.value || '', dotBg: '' });
    }

    // T-486 phase 2: prepend the chosen native axes (Size / Curve Shape) so the closed pill
    // shows the FULL selection, e.g. "95cm · Dark Grey + Natural Beech". Dedup by axis (the
    // mirror renders twice — dialog + inline). Falls back to the placeholder when nothing picked.
    var vmVals = [];
    var vmSeen = {};
    document.querySelectorAll('.ca-vmirror-group').forEach(function(g){
      var axis = g.dataset.caVmirrorAxis || '';
      if (vmSeen[axis]) return;
      var active = g.querySelector('.ca-vmirror-btn--active');
      if (active) { vmSeen[axis] = true; vmVals.push(active.dataset.caVmirrorVal || ''); }
    });
    if (labelEl) {
      var fabricPicked = allPicked.map(function(s){ return s.value; }).filter(function(v){ return v; });
      var vm = vmVals.filter(function(v){ return v; });
      var txt = '';
      if (vm.length) txt = vm.join(' · ');
      if (fabricPicked.length) txt += (txt ? ' · ' : '') + fabricPicked.join(' + ');
      labelEl.textContent = txt || defaultLabel;
    }

    // Dots: one per swatch group (in render order). Paint when the matching
    // swatch is active; revert to muted default when not.
    const dots = trigger.querySelectorAll('.ca-combo-trigger-dot');
    dots.forEach((dot, i) => {
      const slot = swatchPicked[i];
      if (slot && slot.dotBg) {
        dot.style.background = slot.dotBg;
        dot.classList.add('ca-combo-trigger-dot--selected');
      } else {
        dot.style.removeProperty('background');
        dot.classList.remove('ca-combo-trigger-dot--selected');
      }
    });
  }
  // Trigger-dot paint is called at the END of the swatch/select handlers below,
  // AFTER `--active` is applied. A separate document-level listener here would
  // fire before the main handler (listener insertion order) and read stale DOM —
  // dots would always lag one click behind.

  // ============================================================
  // Ported verbatim from snippets/cats-atelier-above-fold.liquid
  // Spec §5.2-§5.3, §9.
  // ============================================================

  var pid = (document.querySelector('.ca-pdp')?.closest('[data-product-id]')?.dataset?.productId) || 'ca';
  var isPlayfulCurve = location.pathname.indexOf('/cat-wall-shelf-the-playful-curve') !== -1;

  function applyScrollLock(durationMs){
    var savedY = window.pageYOffset;
    var html = document.documentElement;
    var origBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    var lockEnd = performance.now() + durationMs;
    var lockLoop = function(){
      window.scrollTo(0, savedY);
      if (performance.now() < lockEnd) requestAnimationFrame(lockLoop);
      else html.style.scrollBehavior = origBehavior;
    };
    requestAnimationFrame(lockLoop);
  }

  // T-751 (2026-08-05): NEVER use a bare document.querySelector('form[action*="cart/add"]').
  // Since T-667 enabled Shopify's native `payment_terms` block (2026-07-25), the FIRST
  // cart/add form in the document is the Klarna installment form ({{ form | payment_terms }}
  // needs its own {% form 'product' %} wrapper, and the block sits above buy_buttons). That
  // form is never submitted, so every properties[...] input appended to it was silently
  // discarded — the customer's Felt/Platform/Base colours vanished from orders #1140-#1143.
  // <product-form> is how theme.js itself locates the real cart form (ProductForm, L2777).
  function caCartForm(){
    return document.querySelector('product-form form[action*="cart/add"]')
        || document.querySelector('form[action*="cart/add"]:not([id$="-payment-installment"])');
  }

  function injectProperty(propName, value){
    var f = caCartForm();
    if(!f) return;
    var safeId = 'ca-prop-' + propName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
    var input = f.querySelector('#' + CSS.escape(safeId));
    if(!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.id = safeId;
      input.name = 'properties[' + propName + ']';
      f.appendChild(input);
    }
    input.value = value;
  }

  // ============================================================
  // T-276 Phase 3 — backwards-compatible chip ↔ variant bridge.
  //
  // After Phase 2 migration, Cushion Color becomes a real Shopify variant
  // option (option3=Color). Prestige's <variant-picker> would auto-render a
  // duplicate Color picker alongside the existing chip UI. The helpers below:
  //   (a) detect whether the product has Color as a variant option
  //   (b) hide the Prestige Color fieldset so chip UI is the sole selector
  //   (c) on chip click, also set the matching variant via the hidden radio
  //       (dual-write per Martin's Option 2 — variant + property)
  //   (d) sync the chip to a variant chosen by URL deep-link or Size change
  //
  // For products NOT yet migrated (no Color option), all four helpers
  // short-circuit cleanly — chip writes property as before. Safe to deploy
  // before any Phase 2 mutation runs.
  // ============================================================

  // T-486 phase 2 (generalised for T-650): click the hidden native radio for ANY
  // axis (Size, Curve Shape, Color, Wood Finish) by matching the fieldset legend + the label text. Prestige's
  // change pipeline (URL, price, gallery, ATC) runs as normal.
  function setVariantByOption(axisName, val){
    if(!axisName || !val) return false;
    var lcAxis = String(axisName).replace(/:/g,'').toLowerCase().trim();
    var lcVal = String(val).toLowerCase().trim();
    var pickers = document.querySelectorAll('variant-picker[context="main_product"], variant-picker:not([context])');
    if(!pickers.length) pickers = document.querySelectorAll('variant-picker');
    for(var p=0;p<pickers.length;p++){
      var fieldsets = pickers[p].querySelectorAll('.variant-picker__option');
      for(var f=0;f<fieldsets.length;f++){
        var legend = fieldsets[f].querySelector('legend');
        var lt = legend ? (legend.textContent||'').replace(/:/g,'').toLowerCase().trim() : '';
        if(lt !== lcAxis) continue;
        var labels = fieldsets[f].querySelectorAll('label');
        for(var i=0;i<labels.length;i++){
          var sr = labels[i].querySelector('.sr-only');
          var ltxt = (sr ? sr.textContent : labels[i].textContent || '').toLowerCase().trim();
          if(ltxt === lcVal){
            var inputId = labels[i].getAttribute('for');
            var input = inputId && document.getElementById(inputId);
            if(input && !input.checked) input.click();
            return true;
          }
        }
      }
    }
    return false;
  }

  // T-650: the checked native radio's value for ANY variant axis (Size, Curve Shape,
  // Color, Wood Finish). Single shared reader — replaces per-axis copies.
  function nativeCheckedValue(axisName){
    var axis = (axisName || '').replace(/:/g,'').toLowerCase().trim();
    var fieldsets = document.querySelectorAll('variant-picker[context="main_product"] .variant-picker__option, variant-picker:not([context]) .variant-picker__option');
    for (var f = 0; f < fieldsets.length; f++) {
      var legend = fieldsets[f].querySelector('legend');
      var lt = legend ? (legend.textContent || '').replace(/:/g,'').toLowerCase().trim() : '';
      if (lt !== axis) continue;
      var checked = fieldsets[f].querySelector('input[type="radio"]:checked');
      if (!checked) return null;
      var lab = fieldsets[f].querySelector('label[for="' + CSS.escape(checked.id) + '"]');
      if (!lab) return null;
      var sr = lab.querySelector('.sr-only');
      return (sr ? sr.textContent : lab.textContent || '').trim();
    }
    return null;
  }

  // T-650 final-review fix: variant-backed is a FUNCTIONAL property, not a declared one.
  // A group only counts as variant-backed if its declared axis actually resolves to a
  // checked native radio on this product. An unmigrated product wrongly carrying the
  // attribute falls back to line-item-property behaviour (with a console.warn) instead
  // of silently writing the choice nowhere — the exact failure class T-650 exists to kill.
  var caWarnedAxes = Object.create(null);
  function isVariantBacked(group){
    var axis = group.dataset.caVariantAxis;
    if (!axis) return false;
    if (nativeCheckedValue(axis) !== null) return true;
    if (!caWarnedAxes[axis]) {
      caWarnedAxes[axis] = true;
      console.warn('[CA PDP] data-ca-variant-axis="' + axis + '" declared but no native variant axis found — falling back to line-item property.');
    }
    return false;
  }

  // T-486 phase 2: re-sync each modal vmirror group's active button from the currently-checked
  // native radio (after init + Prestige section rerender, which can change the checked variant).
  function syncVmirrorFromNative(){
    document.querySelectorAll('.ca-vmirror-group').forEach(function(group){
      var val = nativeCheckedValue(group.dataset.caVmirrorAxis);
      if(!val) return;
      group.querySelectorAll('.ca-vmirror-btn').forEach(function(b){
        var on = (b.dataset.caVmirrorVal === val);
        b.classList.toggle('ca-vmirror-btn--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    // Refresh the closed-pill summary so it reflects the synced Size/Curve (deep-link or rerender).
    updateComboTrigger();
  }

  // T-486 phase 2: hide ALL native variant fieldsets (not just Color). Every axis is now driven
  // from the modal (Size/Curve via vmirror, Color via the cushion-fabric sync), so the native
  // <variant-picker> is the hidden source of truth only. Radios stay in the DOM for programmatic
  // .click() + form submit. Superset of the old Color-only fieldset hider (T-650, retired).
  function hideAllVariantFieldsets(){
    document.querySelectorAll('variant-picker .variant-picker__option').forEach(function(fs){
      if(fs.style.display !== 'none'){ fs.style.display = 'none'; fs.setAttribute('aria-hidden','true'); }
    });
  }

  function reopenDrawerIfClosed(){
    // T-276 Path A v2 (2026-05-12): mostly redundant now that liftDialogToBody
    // protects the dialog from Prestige's section rerender. Kept as belt-and-
    // braces in case the dialog is closed for any other reason (escape key
    // during transition, etc.). Only invoked if the dialog at body level is
    // somehow closed after rerender.
    var dlg = document.querySelector('body > dialog.ca-combo-drawer');
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
      try { dlg.showModal(); } catch(e) { /* ignore transient errors */ }
    }
  }

  function liftDialogToBody(){
    // T-276 Path A v2 (2026-05-12): move the <dialog> out of the main-product
    // section so Prestige's Section Rendering API does not destroy it on
    // variant change. The dialog at body level survives every rerender,
    // staying open + interactive throughout. User no longer sees the modal
    // close + reopen flash on each cushion chip click.
    //
    // Idempotent: skips if dialog is already at body level. Safe to call
    // multiple times (after each rerender's cleanup pass).
    var dialogs = document.querySelectorAll('dialog.ca-combo-drawer');
    if (!dialogs.length) return;
    // Find the canonical dialog (the one we keep): preference order is
    //   1. existing body-level dialog (we already lifted it earlier)
    //   2. first dialog in DOM (about to be lifted)
    var canonical = null;
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i].parentNode === document.body) { canonical = dialogs[i]; break; }
    }
    if (!canonical) canonical = dialogs[0];
    // Move canonical to body if not already there
    if (canonical.parentNode !== document.body) {
      document.body.appendChild(canonical);
    }
    // Remove duplicates Prestige re-rendered inside the section
    for (var j = 0; j < dialogs.length; j++) {
      if (dialogs[j] !== canonical && dialogs[j].parentNode !== document.body) {
        // If the duplicate is open and canonical isn't, transfer open state
        if (dialogs[j].open && !canonical.open && typeof canonical.showModal === 'function') {
          try { canonical.showModal(); } catch(e) { /* ignore */ }
        }
        dialogs[j].remove();
      }
    }
  }

  // #71 (T-542): Cat Wall Step drawer preview = the selected variant's own picture + a words caption.
  // Runs only when the liquid guard rendered .ca-modal-preview[data-ca-preview-source="variant"].
  function updateVariantPreview(variant){
    var box = document.querySelector('.ca-modal-preview[data-ca-preview-source="variant"]');
    if (!box || !variant) return;
    var img = box.querySelector('.ca-modal-preview__img');
    var cap = box.querySelector('.ca-modal-preview__caption');
    var fm = variant.featured_media;
    var src = fm && fm.preview_image && fm.preview_image.src;
    if (img && src) {
      var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      img.setAttribute('alt', ((fm.alt || '') + '').split(' #')[0]);
    } else if (img) {
      // #71 review: a variant with no picture yet (held Brown / unrendered cells) must NOT keep the
      // previous variant's photo under its own caption - blank it (:not([src]) hides it, height reserved).
      img.removeAttribute('src');
      img.setAttribute('alt', '');
    }
    // Positions come from the option NAMES (liquid data attributes); the step also carries a Size axis.
    var o = variant.options || [];
    var fp = parseInt(box.getAttribute('data-ca-felt-pos'), 10), pp = parseInt(box.getAttribute('data-ca-platform-pos'), 10);
    if (cap && fp > -1 && pp > -1 && o[fp] != null && o[pp] != null) cap.textContent = o[fp] + ' felt, ' + o[pp] + ' platform';
  }

  function updateModalPreview(colorValue){
    // T-276 Path A (2026-05-12): set the in-modal preview image src to match
    // the chip-selected cushion colour. Reuses the same alt-text-matched
    // images as caCushionSwap (pattern: '<Title> with <Color> DOT cushion').
    // No-op if the preview element isn't rendered (non-cat-shelf product
    // type, or the type's selector branch doesn't include preview markup).
    var preview = document.querySelector('.ca-modal-preview__img');
    if (!preview) return;
    // #71: the Cat Wall Step drives its preview from the selected variant (updateVariantPreview), never from a cushion alt.
    if (preview.parentNode && preview.parentNode.getAttribute('data-ca-preview-source') === 'variant') return;
    if (!colorValue) { preview.removeAttribute('src'); return; }
    var altKey = colorValue + ' DOT cushion';
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.alt && img.alt.indexOf(altKey) !== -1) {
        var src = img.currentSrc || img.src;
        if (src && preview.src !== src) {
          preview.src = src;
          preview.alt = img.alt;
        }
        return;
      }
    }
  }

  // T-650: sync every variant-backed swatch group from its checked native radio.
  // Covers deep-links at init and Prestige section rerenders. Generalises the old
  // Colour-only chip-from-variant sync (whose "first group" ordering assumption
  // is what left Wood Finish unsynced -> Order #1137).
  function syncSwatchesFromNative(){
    var seen = new Set();
    document.querySelectorAll('.ca-swatches[data-ca-variant-axis]').forEach(function(group){
      var axis = group.dataset.caVariantAxis;
      var prop = group.dataset.caProperty;
      if (!axis || !prop || seen.has(prop)) return;
      seen.add(prop);
      var val = nativeCheckedValue(axis);
      if (!val) return;
      document.querySelectorAll('.ca-swatches[data-ca-property="' + CSS.escape(prop) + '"] .ca-swatch').forEach(function(s){
        s.classList.toggle('ca-swatch--active', s.dataset.caVal === val);
      });
      caSelectedState[prop] = val;
      // NO injectProperty here — the variant IS the record for this axis (T-650).
      // T-754: no applyFollowDefaults() call — changing the cushion must not move Base Fabric.
    });
    updateComboTrigger();
    updatePopularLabel();
  }

  function caCushionSwap(colourVal){
    var altKey = colourVal + ' DOT cushion';
    var thumbs = document.querySelectorAll('.product-gallery__thumbnail img');
    var swapped = false;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].alt && thumbs[i].alt.indexOf(altKey) !== -1) {
        thumbs[i].closest('.product-gallery__thumbnail').click();
        swapped = true;
        break;
      }
    }
    // T-483: only scroll to the gallery when an image actually swapped. On accessory
    // PDPs (no per-colour "DOT cushion" image) the old unconditional scrollIntoView
    // fired on every colour click, producing a pointless, jarring smooth-scroll.
    if (swapped) {
      var gallery = document.querySelector('product-gallery');
      if (gallery) gallery.scrollIntoView({behavior:'smooth', block:'start'});
    }
  }

  function allChosen(){
    var groups = document.querySelectorAll('.ca-swatches[data-ca-required="true"]');
    for(var i=0;i<groups.length;i++) if(!groups[i].querySelector('.ca-swatch--active')) return false;
    var selects = document.querySelectorAll('.ca-select[data-ca-required="true"]');
    for(var j=0;j<selects.length;j++) if(selects[j].value === '') return false;
    return true;
  }

  function maybeRemoveOverlay(){
    if(allChosen()){
      var ov = document.getElementById('ca-express-overlay-' + pid);
      if(ov) ov.remove();
    }
  }

  // Outer trigger error — only meaningful on mobile where the drawer is closed and
  // inner per-field errors are offscreen. Scoped so the mobile pill carries a visible
  // "Please choose..." message whenever ATC fails with required fields unfilled; inner
  // per-field errors continue to pinpoint which field is missing once the drawer opens.
  function setTriggerError(show){
    var wrap = document.querySelector('.ca-combo-trigger-wrap');
    if(!wrap) return;
    if(getComputedStyle(wrap).display === 'none') return; // desktop — no trigger to flag
    var btn = wrap.querySelector('.ca-combo-trigger');
    var msg = wrap.querySelector('.ca-combo-trigger-error');
    if(show){
      if(btn) btn.classList.add('ca-combo-trigger--error');
      if(msg) msg.hidden = false;
    } else {
      if(btn) btn.classList.remove('ca-combo-trigger--error');
      if(msg) msg.hidden = true;
    }
  }

  function validate(){
    // Belt-and-braces: if the user clicked ATC mid-rerender (before the setTimeout
    // restore fires), re-apply our state here so validate() sees the canonical truth,
    // not the freshly-rendered empty server HTML.
    restoreSelections();
    var valid = true, firstBad = null;
    document.querySelectorAll('.ca-swatches[data-ca-required="true"]').forEach(function(group){
      var ok = !!group.querySelector('.ca-swatch--active');
      var errEl = group.closest('.ca-selector-group').querySelector('.ca-selector-error');
      if(!ok){
        group.classList.add('ca-swatches--error');
        if(errEl) errEl.classList.add('ca-selector-error--visible');
        if(!firstBad) firstBad = errEl || group;
        valid = false;
      } else {
        group.classList.remove('ca-swatches--error');
        if(errEl) errEl.classList.remove('ca-selector-error--visible');
      }
    });
    document.querySelectorAll('.ca-select[data-ca-required="true"]').forEach(function(sel){
      var errEl = sel.closest('.ca-selector-group').querySelector('.ca-selector-error');
      if(sel.value === ''){
        sel.classList.add('ca-selector-select--error');
        if(errEl) errEl.classList.add('ca-selector-error--visible');
        if(!firstBad) firstBad = errEl || sel;
        valid = false;
      } else {
        sel.classList.remove('ca-selector-select--error');
        if(errEl) errEl.classList.remove('ca-selector-error--visible');
        injectProperty(sel.dataset.caProperty, sel.value);
      }
    });
    // Mobile: flag the outer pill when drawer is closed. Prefer scrolling to the pill
    // (not a hidden inner field) so the customer actually sees the error.
    var triggerWrap = document.querySelector('.ca-combo-trigger-wrap');
    var triggerVisible = triggerWrap && getComputedStyle(triggerWrap).display !== 'none';
    if(!valid && triggerVisible){
      setTriggerError(true);
      firstBad = triggerWrap;
    } else {
      setTriggerError(false);
    }
    if(!valid && firstBad) firstBad.scrollIntoView({behavior:'smooth', block:'center'});
    return valid;
  }

  function hasCAFields(){
    return document.querySelector('.ca-swatches[data-ca-required="true"]') ||
           document.querySelector('.ca-select[data-ca-required="true"]');
  }

  // Swatch click: mark active, inject, first-swatch triggers caCushionSwap, else scroll-lock
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.ca-swatch');
    if(!btn) return;
    var group = btn.closest('.ca-swatches');
    if(!group || !group.dataset.caProperty) return;
    var prop = group.dataset.caProperty;
    // Match by data-ca-property, NOT element identity. The selectors render twice
    // (mobile dialog + desktop inline) so the FIRST .ca-swatches node in DOM is the
    // dialog's Upper Cushion Fabric group. Desktop clicks fire on the INLINE copy —
    // using element equality would skip caCushionSwap entirely on desktop, so the
    // gallery image wouldn't swap and the page wouldn't scroll on fabric change.
    var firstGroup = document.querySelector('.ca-swatches[data-ca-required="true"]');
    var isFirstSwatch = !!firstGroup && firstGroup.dataset.caProperty === prop;
    // Apply --active to ALL groups with this same property (mobile dialog + desktop inline
    // render the same group twice). Previous behaviour only updated the group clicked,
    // leaving the other copy visually stale.
    document.querySelectorAll('.ca-swatches[data-ca-property="' + CSS.escape(prop) + '"] .ca-swatch').forEach(function(s){ s.classList.remove('ca-swatch--active'); });
    document.querySelectorAll('.ca-swatches[data-ca-property="' + CSS.escape(prop) + '"] .ca-swatch[data-ca-val="' + CSS.escape(btn.dataset.caVal || '') + '"]').forEach(function(s){ s.classList.add('ca-swatch--active'); });
    document.querySelectorAll('.ca-swatches[data-ca-property="' + CSS.escape(prop) + '"]').forEach(function(g){ g.classList.remove('ca-swatches--error'); });
    var errEl = group.closest('.ca-selector-group').querySelector('.ca-selector-error');
    if(errEl) errEl.classList.remove('ca-selector-error--visible');
    // Remember selection in the module-level state store so we can restore after rerender.
    caSelectedState[prop] = btn.dataset.caVal || '';
    // T-650 axis pipeline: variant-backed groups drive the native radio (Prestige runs
    // URL/price/gallery/ATC); property-backed groups inject the line-item property.
    // A variant-backed axis NEVER writes a property — one record per axis.
    var vAxis = isVariantBacked(group) ? group.dataset.caVariantAxis : null;
    if (vAxis) {
      setVariantByOption(vAxis, btn.dataset.caVal);
      setTimeout(liftDialogToBody, 550);
      setTimeout(liftDialogToBody, 1100);
      // T-754: changing a variant-backed axis (the cushion Colour) no longer drags Base
      // Fabric along with it. restoreSelections() re-applies the customer's Base Fabric from
      // caSelectedState after Prestige's rerender, so it survives the section swap unchanged.
    } else {
      injectProperty(prop, btn.dataset.caVal);
    }
    if (isFirstSwatch) {
      // Gallery swap + in-modal preview track the cushion colour as before. The variant
      // click above already ran Prestige's pipeline (the old per-colour variant setter is
      // retired — subsumed by setVariantByOption via data-ca-variant-axis).
      caCushionSwap(btn.dataset.caVal);
      updateModalPreview(btn.dataset.caVal);
    }
    else if (!vAxis) applyScrollLock(500);
    maybeRemoveOverlay();
    updateComboTrigger();
    updatePopularLabel();
    applyFinishPreview();        // T-539: reflect the colour+finish combo in the preview + hero
    // Any selection event clears the outer pill error — the customer has started responding to the prompt.
    setTriggerError(false);
  });

  // Dropdown change (house): inject + scroll-lock
  document.addEventListener('change', function(e){
    var sel = e.target;
    if(!sel.dataset || !sel.dataset.caProperty) return;
    var prop = sel.dataset.caProperty;
    // Mirror to every select with the same property (dialog + inline render twice).
    document.querySelectorAll('.ca-select[data-ca-property="' + CSS.escape(prop) + '"]').forEach(function(s){
      s.value = sel.value;
      s.classList.remove('ca-selector-select--error');
    });
    var errEl = sel.closest('.ca-selector-group').querySelector('.ca-selector-error');
    if(errEl) errEl.classList.remove('ca-selector-error--visible');
    if(sel.value !== '') {
      caSelectedState[prop] = sel.value;
      injectProperty(prop, sel.value);
    }
    applyScrollLock(500);
    maybeRemoveOverlay();
    updateComboTrigger();
    updatePopularLabel();
    // Any selection event clears the outer pill error — the customer has started responding to the prompt.
    if(sel.value !== '') setTriggerError(false);
  });

  function isDefaultSelection() {
    if (!caPopular) return false;
    var keys = Object.keys(caPopular);
    if (!keys.length) return false;
    for (var i = 0; i < keys.length; i++) {
      if (caSelectedState[keys[i]] !== caPopular[keys[i]]) return false;
    }
    return true;
  }

  function updatePopularLabel() {
    var lbl = document.querySelector('.ca-combo-trigger-popular');
    if (!lbl) return;
    lbl.hidden = !isDefaultSelection();
  }

  // T-650: Liquid renders active state from the landed variant, so this reads the DOM
  // truth (deep-link-correct) rather than asserting hardcoded defaults. Properties are
  // injected ONLY for axes with no variant backing.
  function initSelections() {
    var seen = new Set();
    var firstSwatchVal = null;
    document.querySelectorAll('.ca-swatches[data-ca-required="true"]').forEach(function(group) {
      var prop = group.dataset.caProperty;
      if (seen.has(prop)) return;
      seen.add(prop);
      var active = group.querySelector('.ca-swatch--active');
      if (active && active.dataset.caVal) {
        var val = active.dataset.caVal;
        caSelectedState[prop] = val;
        if (!isVariantBacked(group)) injectProperty(prop, val);
        if (firstSwatchVal === null) firstSwatchVal = val;
      }
    });
    document.querySelectorAll('.ca-select[data-ca-required="true"]').forEach(function(sel) {
      var prop = sel.dataset.caProperty;
      if (seen.has(prop)) return;
      seen.add(prop);
      if (sel.value) {
        caSelectedState[prop] = sel.value;
        injectProperty(prop, sel.value);
      }
    });
    updateComboTrigger();
    updatePopularLabel();
    restoreSelections();
    if (firstSwatchVal) updateModalPreview(firstSwatchVal);
    applyFinishPreview();
    updateModalPrice();
  }

  // Restore previously-chosen values into the DOM. Called after Prestige replaces
  // the main-product section on variant change. Idempotent — safe to call twice.
  function restoreSelections(){
    var restored = false;
    document.querySelectorAll('.ca-swatches[data-ca-required="true"]').forEach(function(group){
      if (isVariantBacked(group)) return;  // T-650: Liquid re-renders v.selected — the
                                                // variant is the truth; syncSwatchesFromNative
                                                // handles these groups.
      var prop = group.dataset.caProperty;
      var val = caSelectedState[prop];
      if (!val) return;
      group.querySelectorAll('.ca-swatch').forEach(function(s){ s.classList.remove('ca-swatch--active'); });
      var match = group.querySelector('.ca-swatch[data-ca-val="' + CSS.escape(val) + '"]');
      if (match) { match.classList.add('ca-swatch--active'); restored = true; }
      group.classList.remove('ca-swatches--error');
      injectProperty(prop, val);
    });
    document.querySelectorAll('.ca-select[data-ca-required="true"]').forEach(function(sel){
      var prop = sel.dataset.caProperty;
      var val = caSelectedState[prop];
      if (!val) return;
      sel.value = val;
      sel.classList.remove('ca-selector-select--error');
      injectProperty(prop, val);
      restored = true;
    });
    if (restored) {
      updateComboTrigger();
      updatePopularLabel();
      maybeRemoveOverlay();
      setTriggerError(false);
      // T-276 Path A: also refresh modal preview if cushion selection restored.
      var firstGroup = document.querySelector('.ca-swatches[data-ca-required="true"]');
      if (firstGroup) {
        var active = firstGroup.querySelector('.ca-swatch--active');
        if (active && active.dataset.caVal) updateModalPreview(active.dataset.caVal);
      }
      applyFinishPreview();   // T-539: re-apply combo image after Prestige's section rerender
    }
  }

  // Variant-picker scroll lock (Prestige Section Rendering API causes scroll) +
  // restore our selections after the section swap settles. Two passes — the swap
  // typically completes <600ms but can be slower on 3G; the second pass is cheap
  // and idempotent, so no harm done if the first already restored.
  document.addEventListener('click', function(e){
    if(!hasCAFields()) return;
    if(!e.target.closest('variant-picker')) return;
    applyScrollLock(1000);
  }, true);
  document.addEventListener('change', function(e){
    if(!hasCAFields()) return;
    if(!e.target.closest('variant-picker')) return;
    applyScrollLock(1000);
    setTimeout(restoreSelections, 400);
    setTimeout(restoreSelections, 900);
  }, true);

  // T-483: SYNCHRONOUS restore on Prestige's variant:change event — kills the flicker.
  // theme.js variant-picker.selectCombination() dispatches, in order and synchronously
  // (after the section fetch resolves): product:rerender (→ <product-rerender> replaces
  // the section DOM incl. our liquid block, L3432) THEN variant:change (L3439). Handling
  // variant:change synchronously re-applies the user's swatch/select state AFTER the DOM
  // swap but BEFORE the browser paints, so the Liquid-default state never flashes. This
  // replaces the visible ~400ms gap the setTimeout(restoreSelections, 400/900) passes
  // above used to leave (those are kept as an idempotent belt-and-braces fallback for
  // any non-Prestige rerender path). Also re-hides Prestige's duplicate Color picker and
  // re-lifts the dialog in the same pre-paint frame so neither flashes either.
  document.addEventListener('variant:change', function(e){
    if(!hasCAFields()) return;
    // T-539: re-hide ALL native fieldsets (not just Color) after the rerender — otherwise a newly
    // multi-value native axis (e.g. Wood Finish, once it became a variant) reappears as a duplicate
    // plain selector above the CA swatches. The modal swatches remain the only visible selectors.
    hideAllVariantFieldsets();
    // T-752 (2026-08-05): LIFT FIRST. liftDialogToBody() removes the duplicate <dialog> that
    // Prestige just re-rendered inside the section. Until it runs, that duplicate is EARLIER in
    // document order than the canonical body-level dialog, so the document-order queries inside
    // restoreSelections() -> applyFinishPreview() / updateModalPreview() write the new preview
    // image into the node that is about to be deleted, while the canonical keeps the OLD image.
    // Measured live on the Wave PDP: picking a new cushion colour swapped the preview and then
    // reverted it ~800ms later (naturalWidth 800 -> 896 -> 800). Lifting first makes the
    // canonical the only dialog before anything reads or writes it.
    liftDialogToBody();
    updateVariantPreview(e && e.detail && e.detail.variant);   // #71: after the lift (T-752), step only
    restoreSelections();
    syncSwatchesFromNative();
    updateModalPrice();   // T-543: keep the modal price in sync with the selected variant
  });

  // Window-capture ATC click + submit validation
  window.addEventListener('click', function(e){
    if(!hasCAFields()) return;
    var btn = e.target.closest('button[name="add"]');
    if(!btn) return;
    if(!validate()){ e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('submit', function(e){
    if(!hasCAFields()) return;
    if(!validate()){ e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Playful Curve dip hint
  function addDipHint(){
    if(!isPlayfulCurve) return true;
    var picker = document.querySelector('variant-picker');
    if(!picker) return false;
    if(document.getElementById('ca-dip-hint')) return true;
    var hint = document.createElement('p');
    hint.id = 'ca-dip-hint';
    hint.style.cssText = 'font-size:12px;color:#707070;font-style:italic;margin:4px 0 0;line-height:1.4;';
    hint.textContent = 'The dip is where your cat lounges - choose left or right based on your wall layout.';
    picker.after(hint);
    return true;
  }

  // Express checkout overlay
  function addExpressOverlay(f){
    var btn = f.querySelector('.shopify-payment-button');
    if(!btn) return;
    var existing = document.getElementById('ca-express-overlay-' + pid);
    if(existing) existing.remove();
    btn.style.position = 'relative';
    var ov = document.createElement('div');
    ov.id = 'ca-express-overlay-' + pid;
    ov.style.cssText = 'position:absolute;inset:0;z-index:100;cursor:pointer;background:transparent;';
    ov.addEventListener('click', function(e){
      if(!validate()){ e.stopImmediatePropagation(); e.preventDefault(); }
    });
    btn.appendChild(ov);
  }

  function init(){
    // T-751: must be the REAL cart form, not the Klarna installment form — addExpressOverlay()
    // looks for .shopify-payment-button inside it, which the installment form does not have,
    // so the express-checkout validation guard silently stopped being installed.
    var f = caCartForm();
    if(!f){ requestAnimationFrame(init); return; }
    addExpressOverlay(f);
    setTimeout(function(){ addExpressOverlay(f); }, 300);
    setTimeout(function(){ addExpressOverlay(f); }, 1200);
    if(isPlayfulCurve && !addDipHint()) setTimeout(addDipHint, 300);
    // T-486 phase 2: hide ALL native variant fieldsets (Size/Curve now mirrored in the
    // modal, Color driven by the fabric sync) BEFORE default-selection logic.
    hideAllVariantFieldsets();
    initSelections();
    // T-276 Phase 3: if URL has ?variant=X selecting a specific Color, sync
    // the swatches to match — overrides the swatch's Liquid default.
    syncSwatchesFromNative();
    // T-486 phase 2: sync the Size/Curve mirror buttons from the checked native radios.
    syncVmirrorFromNative();
    // T-276 Path A v2 (2026-05-12): lift the dialog out of main-product
    // section so it survives Prestige's Section Rendering API rerender.
    // Run on next tick to ensure DOM is stable after initSelections.
    setTimeout(liftDialogToBody, 0);
  }
  init();

  // T-276 Phase 3: Prestige's Section Rendering API re-renders main-product on
  // every variant change. The Color fieldset would reappear and the chip might
  // drift from the variant. Re-hide + re-sync after each rerender. Two passes
  // mirror the existing restoreSelections() timing in the variant-picker change
  // handler at line 381. Also re-lift the dialog (remove any duplicate Prestige
  // re-created in the section).
  document.addEventListener('change', function(e){
    if(!e.target.closest('variant-picker')) return;
    setTimeout(function(){
      hideAllVariantFieldsets();
      liftDialogToBody();   // T-752: before any read/write of the dialog's contents
      syncSwatchesFromNative();
      syncVmirrorFromNative();
    },450);
    setTimeout(function(){
      hideAllVariantFieldsets();
      liftDialogToBody();   // T-752: before any read/write of the dialog's contents
      syncSwatchesFromNative();
      syncVmirrorFromNative();
    },950);
  }, true);

  // T-462 (a11y): keep aria-pressed synced to .ca-swatch--active so screen readers announce the
  // selected colour. A class MutationObserver covers every toggle path (user click, label-driven
  // setColor, variant restore) without editing each one.
  (function caSwatchAria(){
    function sync(){
      document.querySelectorAll('.ca-swatch').forEach(function(s){
        s.setAttribute('aria-pressed', s.classList.contains('ca-swatch--active') ? 'true' : 'false');
      });
    }
    sync();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (muts[i].attributeName === 'class' && t.classList && t.classList.contains('ca-swatch')) { sync(); break; }
        }
      });
      document.querySelectorAll('.ca-swatches').forEach(function(g){
        obs.observe(g, { subtree: true, attributes: true, attributeFilter: ['class'] });
      });
    }
  })();
})();
